export function transformInvoice(invoice) {
  return {
    id: invoice.id,
    name: invoice.name,
    invoiceNumber: invoice.invoiceNumber,
    billDate: invoice.billDate,
    amount: invoice.amount,
    dueDate: invoice.dueDate,
    description: invoice.description,
    fileAttachments: invoice.fileAttachments,
    createdBy: invoice.createdById,
    canDelete: invoice.deleteableOob,
    canEdit: invoice.updatebleOob,
  }
}

export function transformInvoiceForServer(invoice) {
  return {
    name: invoice.name,
    invoiceNumber: invoice.invoiceNumber,
    billDate: invoice.billDate,
    amount: invoice.amount,
    dueDate: invoice.dueDate,
    description: invoice.description,
    fileAttachments: invoice.fileAttachments,
  }
}
